import { ErrorMessage, Field, Form, Formik } from 'formik';
import moment from 'moment';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import React from 'react';
import { Alert, Card, Modal } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as Yup from 'yup';
import { signUp } from '../../store/actions/authActions';

import './auth.css';

const format = 'h:mma';

const now = moment().hour(0).minute(0);
console.log(now)
// class SignUp extends Component {
//   state = {
//     email: '',
//     password: '',
//     username: '',
//     isCounselor: false,
//   }
//   onChange = (value) => {
//     console.log(value && value.format(format));
//   }

//   handleCheckboxChange = (e) => {
//     const target = e.target
//     const checked = target.checked
//     this.setState({
//       [e.target.name]: checked,
//     });
//   }
//   handleChange = (e) => {
//     this.setState({
//       [e.target.id]: e.target.value,
//     })
//   }
//   handleSubmit = (e) => {
//     e.preventDefault();
//     this.props.signUp(this.state);
//   }
//   render() {
//     const { auth, authError } = this.props;
//     if (auth.uid) return <Redirect to='/' />
//     return (
//       <Container className="auth-container" fluid>
//         <Card className="auth-card">

//           <Form onSubmit={this.handleSubmit} style={{ padding: '1rem' }}>
//             <h3>Sign Up</h3>
//             <Form.Group controlId="formBasicEmail">
//               <label htmlFor="email">Email</label>
//               <input className="form-control" type="email" id='email' placeholder="Enter email" onChange={this.handleChange} />
//             </Form.Group>
//             <Form.Group controlId="formBasicPassword">
//               <label htmlFor="password">Password</label>
//               <input className="form-control" type="password" id='password' placeholder="Enter password" onChange={this.handleChange} />
//             </Form.Group>
//             <Form.Group>
//               <label htmlFor="UserName">Username</label>
//               {/* <input className="form-control" type="text" id='username' placeholder="Enter Username" onChange={this.handleChange} /> */}

//               <InputGroup className="mb-2">

//                 <InputGroup.Prepend>
//                   <InputGroup.Text>@</InputGroup.Text>
//                 </InputGroup.Prepend>
//                 <FormControl id="username" placeholder="Enter Username" onChange={this.handleChange} />
//               </InputGroup>
//             </Form.Group>
//             <Form.Group controlId="formHorizontalCheck">

//               <Form.Check name="isCounselor" label="Register as Peer Counselor" onChange={this.handleCheckboxChange} />

//             </Form.Group>

//             {this.state.isCounselor ?

//               <Form.Group>
//                 <label > Pick a Slot</label><br></br><br></br>
//             From {"    "}

//                 <TimePicker
//                   showSecond={false}
//                   defaultValue={now}

//                   onChange={this.onChange}
//                   format={format}
//                   use12Hours
//                   inputReadOnly
//                 />
//                 {"    "} to {"    "}
//                 <TimePicker
//                   showSecond={false}
//                   defaultValue={now}

//                   onChange={this.onChange}
//                   format={format}
//                   use12Hours
//                   inputReadOnly
//                 />
//               </Form.Group>
//               : null
//             }
//             <button type="submit" className="btn button  btn-block">Sign Up</button>

//             <br />
//             <div className="error">
//               {authError ? <p>{authError}</p> : null}
//             </div>

//           </Form>
//         </Card>
//       </Container>
//     )
//   }
// }


class SignUp extends React.Component {

  state={
    show:true
  }
  handleClose = ()=> this.setState({show:false})


  handleSubmit = (values, {
    setSubmitting
  }) => {

    alert(JSON.stringify(values, null, 2));

    setSubmitting(false);

    return;
  }


  render() {
    const { auth, authError } = this.props;
    if (auth.uid) return <Redirect to='/' />

    return (
      <>
        <Formik
          initialValues={{
            gender: '',
            username: '',
            age: '',
            email: '',
            password: '',
            confirmPassword: '',
            qualification: '',
            occupation: '',
            familymembers: '',
            relationshipstatus: '',
            livingsituation: '',
            livingwith: '',
            isFirsttime: true,
            listofpasttherapy: '',
            isCounselor: false,
            from: '',
            to: '',
            acceptTerms: false,
            isConsent:false
          }}
          validationSchema={Yup.object().shape({
            gender: Yup.string()
              .when("isCounselor", {
                is: false,
                then: Yup.string().required('Gender is required'),
              }),

            username: Yup.string()
              .required('Username is required'),
            isConsent: Yup.bool()
              .required('Username is required'),
            isCounselor: Yup.bool(),
            email: Yup.string()
              .email('Email is invalid')
              .matches(`^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+.)?[a-zA-Z]+.)?(amity).edu$`, 'Please sign up using email provided by Amity')
              .required('Email is required'),
            password: Yup.string()
              .min(8, 'Password must be at least 8 characters')
              .required('Password is required'),
            confirmPassword: Yup.string()
              .oneOf([Yup.ref('password'), null], 'Passwords must match')
              .required('Confirm Password is required'),
            age: Yup.string()
              .when("isCounselor", {
                is: false,
                then: Yup.string().required('Age is required')
              })
            ,
            qualification: Yup.string(),
              // .when("isCounselor", {
              //   is: false,
              //   then: Yup.string().required('Qualification is required'),
              // }),

            occupation: Yup.string(),
              // .when("isCounselor", {
              //   is: false,
              //   then: Yup.string().required('Occupation is required'),
              // }),

            familymembers: Yup.string(),
              // .when("isCounselor", {
              //   is: false,
              //   then: Yup.string().required('Family members is required'),
              // }),



            acceptTerms: Yup.bool()
              .oneOf([true], 'Accept Ts & Cs is required')
          })}
          onSubmit={fields => {


            this.props.signUp(fields);

          }}

        >
          {({ errors, touched, values }) => (



            <Container className="auth-container" fluid>
              <Modal
                show={this.state.show}
                onHide={this.handleClose}
                size="xl"
                centered
                dialogClassName="disclaimer"
                
              >
                <Modal.Header  className='justify-content-center' closeButton>
                  <Modal.Title style={{ color: 'tomato' }}>DISCLAIMER </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Any information provided will remain completely confidential and will only be used in 
                  order to improve your Peer Counselling experience with us.
                <br />
                    If you choose, you can consent to contributing this data for research and for 
                    improving Secureस्थल over time as a tool for students' mental health and well being.
        </Modal.Body>
                <Modal.Footer className='justify-content-center'>
                  <div className="form-group form-check">
                    <Field type="checkbox" name="isConsent" className={'form-check-input ' + (errors.isConsent && touched.isConsent ? ' is-invalid' : '')} />
                    <label htmlFor="isConsent" className="form-check-label">Yes, I consent to providing this information for research purposes. </label>
                    <ErrorMessage name="isConsent" component="div" className="invalid-feedback" />

                  </div>
                  
                </Modal.Footer>
                
              </Modal>

              <Card className="auth-card">
               
                <h2 style={{ color: 'black' ,textAlign:'center'}} >{'Sign Up'.toUpperCase()}</h2>
                
                
                  <Form>

                    <div className="error">
                      {authError ?
                        <Alert variant="danger">

                          <Alert.Heading>Error while Signing Up </Alert.Heading>
                          <p>
                            {authError}
                          </p>
                        </Alert>

                        : null}

                    </div>

                    


                    <div className="">
                      <div className="form-group ">
                        <label htmlFor="username">Username</label>
                        <Field name="username" type="text" className={'form-control' + (errors.username && touched.username ? ' is-invalid' : '')} />
                        <ErrorMessage name="username" component="div" className="invalid-feedback" />
                      </div>


                      <div className="form-group ">
                        <label htmlFor="email">Email</label>
                        <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                        <ErrorMessage name="email" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                    <div className="">
                      <div className="form-group ">
                        <label htmlFor="password">Password</label>
                        <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                        <ErrorMessage name="password" component="div" className="invalid-feedback" />
                      </div>
                      <div className="form-group ">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <Field name="confirmPassword" type="password" className={'form-control' + (errors.confirmPassword && touched.confirmPassword ? ' is-invalid' : '')} />
                        <ErrorMessage name="confirmPassword" component="div" className="invalid-feedback" />
                      </div>
                    </div>
                    {values.isCounselor ? this.counselor(values) : this.notcounselor(values, errors, touched)}
                    <div className="form-group form-check">
                      <Field type="checkbox" name="acceptTerms" className={'form-check-input ' + (errors.acceptTerms && touched.acceptTerms ? ' is-invalid' : '')} />
                      <label htmlFor="acceptTerms" className="form-check-label">Accept Terms & Conditions</label>
                      <ErrorMessage name="acceptTerms" component="div" className="invalid-feedback" />
                    </div>

                    <div className="row justify-content-center">

                      <button type="submit" className="btn button mr-2 ">Register </button>
                      <button type="reset" className="btn" style={{ width: '15rem', borderColor: '#40817a', borderRadius: '1rem', margin: '0.2rem', backgroundColor: 'white' }}>Reset</button>
                    </div>

                  </Form>
                
              </Card>

            </Container>





          )}

        </Formik>
      </>
    );
  }
  notcounselor(values, errors, touched) {
    return (
      <div>
        
        <div className="form-group ">
          <label htmlFor="gender">Gender</label>
          <Field name="gender" type="text" className={'form-control' + (errors.gender && touched.gender ? ' is-invalid' : '')} />
          <ErrorMessage name="gender" component="div" className="invalid-feedback" />
        </div>
        <div className="form-group ">
          <label htmlFor="age">Age</label>
          <Field name="age" type="text" className={'form-control' + (errors.age && touched.age ? ' is-invalid' : '')} />
          <ErrorMessage name="age" component="div" className="invalid-feedback" />
        </div>
        <div className="form-group form-check">
        <Field type="checkbox" name="isFirsttime" className={'form-check-input ' + (errors.isFirsttime && touched.isFirsttime ? ' is-invalid' : '')} />
        <label htmlFor="isFirsttime" className="form-check-label">Is this your first time seeking therapy or counselling services? </label>
        <ErrorMessage name="isFirsttime" component="div" className="invalid-feedback" />

      </div>
        {!values.isFirsttime &&
        <div className="form-group ">
          <label htmlFor="listofpasttherapy">If NO, please list down the type of therapy you have tried out in the past: </label>
          <Field name="listofpasttherapy" type="text" className={'form-control' + (errors.listofpasttherapy && touched.listofpasttherapy ? ' is-invalid' : '')} />
          <ErrorMessage name="listofpasttherapy" component="div" className="invalid-feedback" />
        </div>
      }
      </div>
    );

    
  }
  counselor(values) {
    return <div className="form-group">
      <label> Pick a Slot</label><br></br><br></br>
      From {"    "}

      <TimePicker

        showSecond={false}
        defaultValue={now}

        onChange={(value) => {
          values.from = value.format(format);
          console.log("From:" + value.format(format));
        }}
        format={format}
        use12Hours
        inputReadOnly />
      {"    "} to {"    "}
      <TimePicker
        showSecond={false}
        defaultValue={now}

        onChange={(value) => {
          values.to = value.format(format);
          console.log("To:" + value.format(format));
        }}
        format={format}
        use12Hours
        inputReadOnly />
    </div>;
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    authError: state.auth.authError
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signUp: (creds) => dispatch(signUp(creds))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp)
